// extracted by mini-css-extract-plugin
module.exports = {"container":"_3xw9Vx08PnaswxsABlZJtG","heading":"_3esw9W4lY-uO2uijUGmQyt"};